import {DatabaseCode, toDatabaseCode} from "./database-code";

/**
 * The category of transport
 */
export interface ReportTimeType extends DatabaseCode {
}

const daily: ReportTimeType = {
  code: 'DAILY',
  displayValue: {
    id: 'ots.ui.entity.reporttime.type.daily',
    defaultMessage: 'Daily',
  },
};

const weekly: ReportTimeType = {
  code: 'WEEKLY',
  displayValue: {
    id: 'ots.ui.entity.reporttime.type.weekly',
    defaultMessage: 'Weekly',
  },
};

const monthly: ReportTimeType = {
  code: 'MONTHLY',
  displayValue: {
    id: 'ots.ui.entity.reporttime.type.monthly',
    defaultMessage: 'Monthly',
  },
};

const custom: ReportTimeType = {
  code: 'CUSTOM',
  displayValue: {
    id: 'ots.ui.entity.reporttime.type.custom',
    defaultMessage: 'Custom',
  },
};

export const reportTimeType = {
  daily,
  weekly,
  monthly,
  custom,
};

export const reportTimeTypes = Object.values(reportTimeType);

export const toReportTimeType = (code: string): ReportTimeType => toDatabaseCode(code, reportTimeTypes);
